import { PageRouteBaseConfig } from '@/App/AppRoutes/types';

export const ProfilePageRouteBase: PageRouteBaseConfig = {
  key: 'profile-page',
  path: 'profile/:horoscopeType?',
};
